// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"6":"deff17eb","12":"14d743f4","40":"d8456724","139":"e52f0ae3","204":"cf990279","226":"315e8c94","228":"2030e3c1","425":"94c0182d","677":"93ffb6ed","739":"c583701a","744":"34771197"}[chunkId] + ".chunk.js";
};